/* Lukante theme JS */
jQuery(document).ready(function () {
    
    jQuery(window).on("scroll", function () {
        if (jQuery(window).scrollTop() > 1) {
            jQuery("#main-nav").addClass("active-header");

         } else {
            //remove the background property so it comes transparent again (defined in your css)
            jQuery("#main-nav").removeClass("active-header");
        }
    });

});
